/* eslint-disable no-underscore-dangle */

// Point to an <input> part of the combobox.
const parentClass = '.cz-combobox__wrapper';

// Offset of the dropdown
const offset = 5;

/**
 * Setup initial styles.
 */
function calculateBasePosition(el) {
    el.style.width = `${el.offsetWidth}px`;
    el.style.position = 'fixed';
    el.style.bottom = 'auto';
    el.style.zIndex = '50';
    el.style.marginTop = '0px';
}

/**
 * Calculate the dropdown position relative to the <input> box.
 */
function calculateWrapperPosition(el) {
    const relativeNode = el.closest(parentClass);

    // Dropdown position and size.
    const { height } = el.getBoundingClientRect();

    // Parent position and size.
    const { left, top: relativeTop, height: relativeHeight } = relativeNode.getBoundingClientRect();

    // Window size.
    const windowHeight = window.innerHeight;

    let isBelow = true;

    // Do we have space below?
    if (relativeTop + relativeHeight + height + offset >= windowHeight) {
        isBelow = false;
    }

    let newTop;

    if (isBelow) {
        newTop = relativeTop + relativeHeight + offset;
    } else {
        newTop = relativeTop - offset - height;
    }

    el.style.top = `${newTop}px`;
    el.style.left = `${left}px`;
}

/**
 * Given an element, find a closest scrollable parent.
 */
function closestScrollable(node) {
    let currentNode = node.parentNode;

    while (currentNode && currentNode !== document) {
        const style = window.getComputedStyle(currentNode);

        if (style.overflow === 'auto'
            || style.overflow === 'scroll'
            || style.overflowY === 'auto'
            || style.overflowY === 'scroll'
            || style.overflowX === 'auto'
            || style.overflowX === 'scroll'
        ) {
            return currentNode;
        }

        currentNode = currentNode.parentNode;
    }

    return document;
}

/**
 * Attach to an element.
 */

function attachToElement(el, binding) {
    // Assuming el is already in DOM...

    const scrollableContainer = closestScrollable(el);

    calculateBasePosition(el, binding);

    const calculatePositionCallback = () => {
        calculateWrapperPosition(el);
    };

    calculatePositionCallback();

    el._calculatePositionCallback = calculatePositionCallback;

    // Recalculate positions when scrolled.
    scrollableContainer.addEventListener('scroll', calculatePositionCallback);
    document.addEventListener('scroll', el._calculatePositionCallback);

    // Create a new MutationObserver that recalculates the position when the children of parentElement are modified.
    const observer = new MutationObserver(calculatePositionCallback);
    observer.observe(scrollableContainer, { childList: true });

    el._observer = observer;
}

export default {

    mounted(el, binding) {
        attachToElement(el, binding);
    },

    // eslint-disable-next-line no-unused-vars
    beforeUnmount(el, binding) {
        const scrollableContainer = closestScrollable(el);

        // Disconnect observers.
        el._observer?.disconnect();
        el._ownObserver?.disconnect();

        scrollableContainer?.removeEventListener('scroll', el._calculatePositionCallback);
        document.removeEventListener('scroll', el._calculatePositionCallback);
    },
};
